import { OfferFilesScreen } from "./offer-files.screen";
import { Paths } from "../../routes/paths";
import { type RouteDefinition } from "../../routes/route-definition";

export const OfferFilesRoutes: RouteDefinition[] = [
	{
		path: Paths.offerFiles.path,
		element: <OfferFilesScreen />,
		requiredPermissions: "onlyOwnerOfRoot",
	},
];
